import { render } from "./PublicLayout.vue?vue&type=template&id=5d6369e7"
import script from "./PublicLayout.vue?vue&type=script&lang=ts"
export * from "./PublicLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script